"use client";
import { useState, useEffect, useContext, useRef } from "react";
import Link from "next/link";
import {
  FiShoppingCart,
  FiUser,
  FiChevronDown,
  FiSearch,
  FiMenu,
  FiX,
} from "react-icons/fi";
import AuthContext from "../context/AuthContext";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [carrito, setCarrito] = useState([]);

  const { user, logout } = useContext(AuthContext);
  const timeoutRef = useRef(null);

  const categories = [
    {
      name: "Invernadero",
      subcategories: [
        { name: "Plástico", img: "/images/plastico.png" },
        { name: "Pernería", img: "/images/cinta.png" },
        { name: "Clavos", img: "/images/geomembrana.png" },
        { name: "Rodelas", img: "/images/invernadero.webp" },
      ],
    },
    {
      name: "Riego",
      subcategories: [
        { name: "Aspersores", img: "/images/cintasde-goteo.png" },
        { name: "Cintas de Goteo", img: "/images/cinta.png" },
        { name: "Nebulizadores", img: "/images/maquinaria.png" },
      ],
    },
    {
      name: "Ordeño",
      subcategories: [
        { name: "Pezoneras", img: "/images/pezoneras.jpg" },
        { name: "Baldes", img: "/images/baldes.jpg" },
      ],
    },
  ];


  useEffect(() => {
    const updateCarrito = () => {
      const data = JSON.parse(localStorage.getItem("carrito")) || [];
      setCarrito(data);
    };

    updateCarrito();
    window.addEventListener("storage", updateCarrito);
    window.addEventListener("carritoUpdated", updateCarrito);

    return () => {
      window.removeEventListener("storage", updateCarrito);
      window.removeEventListener("carritoUpdated", updateCarrito);
    };
  }, []);

  const totalCarrito = carrito.reduce((t, i) => t + i.cantidad, 0);


  useEffect(() => {
    document.body.style.overflow = mobileMenu ? "hidden" : "";
  }, [mobileMenu]);


  const handleMouseEnter = (menu) => {
    clearTimeout(timeoutRef.current);
    setMenuOpen(menu);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setMenuOpen(null), 150);
  };

  const closeMobileMenu = () => setMobileMenu(false);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">

      <div className="bg-green-700 text-white text-sm py-1 hidden md:block">
        <div className="max-w-7xl mx-auto px-4 flex justify-between">
          <span>🌿 Innovación y confianza para el crecimiento del campo ecuatoriano</span>
          <span>📞 +593 995 149 001</span>
        </div>
      </div>


      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

        <Link href="/">
          <img src="/images/logo.png" alt="Logo" className="w-40 md:w-48" />
        </Link>

        <div className="hidden md:flex relative w-full max-w-xl mx-8">
          <input
            placeholder="Buscar productos agrícolas..."
            className="text-center w-full border border-gray-300 rounded-full px-5 py-2
              text-gray-700 placeholder-gray-400
              focus:ring-2 focus:ring-green-600 focus:border-green-600 outline-none"
          />
          <FiSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-green-700" />
        </div>

        {/* ICONOS */}
        <div className="flex items-center gap-4">
          <Link href="/" className="relative group">
            <FiShoppingCart
              size={26}
              className="text-gray-700 group-hover:text-green-700 transition"
            />
            {totalCarrito > 0 && (
              <span className="absolute -top-2 -right-3 bg-green-700 text-white text-xs font-bold px-2 py-[2px] rounded-full shadow">
                {totalCarrito}
              </span>
            )}
          </Link>

          {/* PC */}
          <div
            className="relative hidden md:block"
            onMouseEnter={() => handleMouseEnter("user")}
            onMouseLeave={handleMouseLeave}
          >
            <FiUser
              size={26}
              className="text-gray-700 hover:text-green-700 transition"
            />
            {menuOpen === "user" && (
              <div className="absolute right-0 mt-3 w-56 bg-white shadow-xl rounded-xl p-2">
                {user ? (
                  <>
                    <p className="px-4 py-2 font-semibold text-gray-800">
                      Hola, {user.username}
                    </p>
                    <Link
                      href="/"
                      className="block px-4 py-2 rounded hover:bg-green-50"
                    >
                      Perfil
                    </Link>
                    <button
                      onClick={logout}
                      className="block w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 rounded"
                    >
                      Cerrar sesión
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      href="/"
                      className="block px-4 py-2 rounded hover:bg-green-50 text-gray-800"
                    >
                      Login
                    </Link>
                    <Link
                      href="/"
                      className="block px-4 py-2 rounded hover:bg-green-50 text-gray-800"
                    >
                      Registro
                    </Link>
                  </>
                )}
              </div>
            )}
          </div>

          {/* MENU HAMBUERGUESA */}
          <button
            onClick={() => setMobileMenu(!mobileMenu)}
            className="md:hidden text-2xl text-green-700"
          >
            {mobileMenu ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>

      {/* MENU PC 
      <div className="hidden md:block border-t bg-white">
        <div className="max-w-7xl mx-auto flex justify-center gap-10 py-4 font-semibold text-gray-800">
          <Link href="/" className="hover:text-green-700 transition">
            Empresa
          </Link>

          <div
            className="relative"
            onMouseEnter={() => handleMouseEnter("productos")}
            onMouseLeave={handleMouseLeave}
          >
            <button className="flex items-center gap-1 hover:text-green-700 transition">
              Productos <FiChevronDown />
            </button>

            {menuOpen === "productos" && (
              <div className="absolute left-0 mt-4 w-[900px] bg-white shadow-2xl rounded-2xl p-6 flex">
                <div className="w-1/4 border-r pr-4 space-y-1">
                  {categories.map((c, i) => (
                    <p
                      key={i}
                      onMouseEnter={() => setSelectedCategory(c)}
                      className={`px-4 py-2 rounded-lg cursor-pointer transition
                        ${
                          selectedCategory?.name === c.name
                            ? "bg-green-700 text-white shadow"
                            : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                        }`}
                    >
                      {c.name}
                    </p>
                  ))}
                </div>

                <div className="w-3/4 pl-6 grid grid-cols-4 gap-6">
                  {selectedCategory?.subcategories.map((s, i) => (
                    <Link
                      key={i}
                      href={`/categorias/${selectedCategory.name}/${s.name}`}
                      className="text-center text-gray-700 hover:text-green-700 transition"
                    >
                      <img
                        src={s.img}
                        alt={s.name}
                        className="w-20 h-20 rounded-full mx-auto object-cover"
                      />
                      <p className="mt-2 text-sm font-medium">{s.name}</p>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          <Link href="/" className="hover:text-green-700 transition">
            Tienda Virtual
          </Link>
          <Link href="/" className="hover:text-green-700 transition">
            Galería
          </Link>
          <Link href="/" className="hover:text-green-700 transition">
            Preguntas frecuentes
          </Link>
        </div>
      </div>
*/}
      {/*MENU MOVIL 
      {mobileMenu && (
        <div className="fixed inset-0 z-[999] md:hidden">
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={closeMobileMenu}
          />

          <div className="absolute top-0 left-0 right-0 bg-white rounded-b-2xl shadow-2xl px-6 py-6">
            <div className="relative mb-6">
              <input
                placeholder="Buscar productos..."
                className="w-full border border-gray-300 rounded-full px-5 py-2 pr-10
                  text-gray-700 focus:ring-2 focus:ring-green-600 outline-none"
              />
              <FiSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-green-700" />
            </div>

            <div className="flex flex-col gap-5 text-lg font-semibold text-gray-800">
              {[
                ["Empresa", "/nosotros"],
                ["Tienda Virtual", "/catalogo"],
                ["Galería", "/galeria"],
                ["Preguntas frecuentes", "/preguntas"],
              ].map(([label, href]) => (
                <Link
                  key={href}
                  href={href}
                  onClick={closeMobileMenu}
                  className="hover:text-green-700 transition"
                >
                  {label}
                </Link>
              ))}
            </div>

            <hr className="my-6" />

            <div className="flex flex-col gap-4">
              {user ? (
                <>
                  <span className="text-sm text-gray-500">
                    Sesión iniciada como
                  </span>
                  <span className="font-bold text-green-700">
                    {user.username}
                  </span>
                  <Link
                    href="/perfil"
                    onClick={closeMobileMenu}
                    className="hover:text-green-700"
                  >
                    Perfil
                  </Link>
                  <button
                    onClick={() => {
                      logout();
                      closeMobileMenu();
                    }}
                    className="text-red-600 font-semibold text-left"
                  >
                    Cerrar sesión
                  </button>
                </>
              ) : (
                <>
                  <Link
                    href="/login"
                    onClick={closeMobileMenu}
                    className="bg-green-700 text-white text-center py-3 rounded-xl font-bold hover:bg-green-800 transition"
                  >
                    Iniciar sesión
                  </Link>
                  <Link
                    href="/registro"
                    onClick={closeMobileMenu}
                    className="border-2 border-green-700 text-green-700 text-center py-3 rounded-xl font-bold hover:bg-green-50 transition"
                  >
                    Registrarse
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}*/}
    </nav>
  );
}
